<template>
    <section aria-labelledby="primary-heading" class="p-2 relative flex flex-col w-full min-h-0 flex-1 md:order-2">

        <slot/>
    </section>
</template>

<script>
export default {
    name: "page",

}
</script>